export default defineI18nLocale(locale => {
  return $fetch(`https://poeditor.brainz.cz/728836/${locale}.json`)
})